import { createContext, useContext } from "react";
import type { InterfaceDesign } from "../../../util/src/design/visual-variants.js";
import type { InterfaceColorMode } from "../../../util/src/design/tokens.js";
export type CompositionTheme = {
  mode: InterfaceDesign;
  color: InterfaceColorMode;
};
export const CompositionThemeContext = createContext<
  CompositionTheme | undefined
>(undefined);
export const useCompositionTheme = () => useContext(CompositionThemeContext);
